/**
 * Чужой перенос карточки (task.moved) — точечно в кэш, без перезапроса
 * доски: при живой работе нескольких человек перезапрашивать доску на каждое
 * чужое перетаскивание недопустимо. Одно правило для веба и приложения.
 */

import { api } from "../api";
import { tasksApi, type TaskFilters } from "./api";
import { applyMove } from "./applyMove";

interface MovedPayload {
  taskKey?: string;
  toColumnId?: string;
  version?: number;
  position?: number;
  afterTaskKey?: string | null;
}

/** То, что функция отправляет: правка кэша списка и сброс истории задачи.
 *  dispatch веба и приложения принимает и то и другое. */
type MovedDispatch = (
  action:
    | ReturnType<typeof tasksApi.util.updateQueryData>
    | ReturnType<typeof api.util.invalidateTags>,
) => unknown;

export function applyTaskMovedEvent(dispatch: MovedDispatch, state: unknown, payload: unknown): void {
  const { taskKey, toColumnId, version, position, afterTaskKey } = (payload ?? {}) as MovedPayload;
  if (taskKey === undefined || toColumnId === undefined) return;
  // Типы состояния у веба и приложения свои; кэш API у них общий по форме.
  const cache = state as Parameters<typeof tasksApi.util.selectInvalidatedBy>[0];
  for (const entry of tasksApi.util.selectInvalidatedBy(cache, ["TaskList"])) {
    dispatch(
      tasksApi.util.updateQueryData("tasks", entry.originalArgs as TaskFilters, (draft) => {
        // Место в столбце — то же правило, что у своего переноса.
        applyMove(draft.data, {
          taskKey,
          toColumnId,
          position: typeof position === "number" ? position : Number.MAX_SAFE_INTEGER,
          afterTaskKey,
        });
        // Без новой версии чужой перенос оставлял в кэше старую,
        // и свой следующий перенос этой карточки получал 409.
        const task = draft.data.find((item) => item.key === taskKey);
        if (task && typeof version === "number") task.version = version;
      }),
    );
  }
  // Доску не перезапрашиваем, но перенос попадает в историю задачи,
  // а открытая карточка показывает новый столбец и версию — без этого
  // столбец в ней менялся только после ручного обновления, а следующая
  // правка из карточки получала 409. Неоткрытую карточку сброс не грузит.
  dispatch(api.util.invalidateTags([{ type: "Task", id: taskKey }, "Events"]));
}
